import { combineReducers, createStore } from "redux"
import { locationReducer } from "components/StoreFinder/reducer"

const combinedReducers = combineReducers({ locationReducer })

export const store = createStore(combinedReducers)
